export { InputLocation, QueryType } from './InputLocation';
